import React, { useState, useEffect } from 'react';
import MapService from './../utils/MapService';
import Slider from "react-slick";
import SubsidiaryItem from './bper-subsidiary-item';

export default function ClosestSubsidiaries({ bank, translations, groupId, subsidiaryId }) {
	const [configurations, setConfigurations] = useState(undefined);
	const [subsidiaries, setSubsidiaries] = useState(undefined);
	const apiKey = configurations && configurations.googleApiKey;
	const [isCarousel, setIsCarousel] = useState(false);

	useEffect(() => {
		getConfigurations(bank);
		detectCarousel(subsidiaries);
	}, []);

	useEffect(() => {
		configurations && getClosestSubsidiaries(configurations.countClosestSubsidiaries);
	}, [configurations]);

	useEffect(() => {
		detectCarousel(subsidiaries);
	}, [window.innnerWidth]);

	const detectCarousel = (subsidiaries) => {
		if (window.innnerWidth > 1000) {
			setIsCarousel(subsidiaries && subsidiaries.length > 3);
		} else {
			if (window.innnerWidth > 767) {
				setIsCarousel(subsidiaries && subsidiaries.length > 3);
			} else {
				setIsCarousel(subsidiaries && subsidiaries.length > 2);
			}
		}
	}

	const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 767,
				settings: {
					infinite: true,
					centerMode: true,
					slidesToShow: 1,
				}
			}
		]
	}

	const getConfigurations = (bank) => {
		MapService.getConfigurations(bank).then((response) => {
			if (response) {
				setConfigurations(response.data);
			}
		});
	};

	const getClosestSubsidiaries = (limitResults) => {
		MapService.getClosestSubsidiary(bank, limitResults, groupId, subsidiaryId).then((response) => {
			const subsidiaries = response?.data?.payload?.subsidiaryListGeoloc
			if (subsidiaries) {
				setSubsidiaries(subsidiaries);
				detectCarousel(subsidiaries);
			}
		});
	}

	return (
		<div className="filiali-bper">
			{subsidiaries &&
				<div className={"closest-subsidiaries n-" + subsidiaries.length + " is-carousel-" + isCarousel}>
					<div className="bper-wrapper ">
						<h3>
							{translations.closestPortletTitle}
						</h3>
						{
							isCarousel ?
								<Slider {...settings}>
									{subsidiaries.map((el, index) =>
										<SubsidiaryItem key={index} translations={translations} apiKey={apiKey} subsidiary={el} />
									)}
								</Slider>
								:
								<div className="all-subsidiaries">
									{subsidiaries.map((el, index) =>
										<SubsidiaryItem key={index} translations={translations} apiKey={apiKey} subsidiary={el} />
									)}
								</div>
						}
					</div>
				</div>
			}
		</div>
	);
}